/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbShipping_viewer$ref = any;
type PdpSharedBlurbSupportNumber_viewer$ref = any;
export type PdpRespSidebarBlurbs_viewer$ref = any;
export type PdpRespSidebarBlurbs_viewer = {
    readonly isConsultAnExpertDisabled?: boolean | null;
    readonly " $fragmentRefs": PdpSharedBlurbShipping_viewer$ref & PdpSharedBlurbSupportNumber_viewer$ref;
    readonly " $refType": PdpRespSidebarBlurbs_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isConsultAnExpertDisabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "DISABLE_CONSULT_AN_EXPERT"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
        }
      ]
    }
  ]
};
(node as any).hash = '2d2511a8283ee53791bf50bf755938fd';
export default node;
